import React from "react";

import { Activity } from "lucide-react";

import Dashboard from "./Dashboard";
import PageHeader from "../../Components/PageHeader";

const AlwaysOnChannel: React.FC = () => {
  return (
    <div className="mt-3 flex flex-col bg-white">
      <PageHeader title="Always On Intelligence" icon={Activity} />
      <div className="w-full bg-white p-3 md:p-4">
        <div className="flex flex-col rounded-md bg-gray-100 p-4 md:p-4">
          <Dashboard />
        </div>
      </div>
    </div>
  );
};

export default AlwaysOnChannel;
